import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { roadmapSettingsResource } from '@jira/router-resources__roadmap/src/roadmapSettingsResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareBoardsRoadmapRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareBoardsRoadmapRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { RoadmapSettingsRedirectToTimelineSettings } from './ui/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import { LazyRoadmap } from './ui/project-settings/product-routes/software/board-settings/roadmap/index.tsx';

// TODO: Delete this file when clean up timeline harmonisation M3 (fg: jira_timeline_harmonisation_m3)
export const projectSettingsSoftwareBoardsRoadmapRouteEntry: Route = createEntry(
	projectSettingsSoftwareBoardsRoadmapRoute,

	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: RoadmapSettingsRedirectToTimelineSettings,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources(), roadmapSettingsResource],
		forPaint: [LazyAtlassianNavigation, LazyRoadmap],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
